/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import OffersModal from './OffersModal';

function OffersModalVM({ availableOffers, onClose, appliedCode }) {
  const globalOffers = availableOffers.filter((offer) => !offer.personalized_offer);
  const personalizedOffers = availableOffers.filter((offer) => offer.personalized_offer);
  return (
    <OffersModal
      globalOffers={globalOffers}
      personalizedOffers={personalizedOffers}
      appliedCode={appliedCode}
      onClose={onClose}
    />
  );
}

OffersModalVM.propTypes = {
  availableOffers: PropTypes.arrayOf(PropTypes.shape({})),
  onClose: PropTypes.func,
  appliedCode: PropTypes.string,
};

export default OffersModalVM;
